import { toRaw } from 'vue';

export const toRawDeep = <T>(observed: T): T => {
  const val = toRaw(observed);

  // add any classes, that you want to support:
  if (val instanceof Date) {
    return val;
  }

  if (Array.isArray(val)) {
    return val.map(toRawDeep) as T;
  }

  // eslint-disable-next-line eqeqeq
  if (val === null) {
    return null as T;
  }

  if (typeof val === 'object') {
    const entries = Object.entries(val).map(([key, val]) => [
      key,
      toRawDeep(val),
    ]);

    return Object.fromEntries(entries);
  }

  return val;
};
